export default __webpack_public_path__ + "static/media/sarbagya_dhaubanjar.c9575515.jpg";